import Merchandising from "app/pages/Listing/merchandising/Merchandising";
import MerchandisingCarousel from "@brand/MerchandisingCarousel/MerchandisingCarousel";
import BackgroundProgressiveImg from "app/pages/.shared/BackgroundProgressiveImg";
import get from "lodash/get";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";
import { LISTING_ITEM_TYPES } from "app/constants";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { useEffect, useRef } from "react";
import useOnScreen from "app/pages/.shared/useOnScreen";

const MERCH_CLOUDINARY_OPTIONS = ["c_crop"];

const IMG_SIZES_LARGE = {
	large: { width: 1024, height: 415 },
	xlarge: { width: 1024, height: 415 },
};

const IMG_SIZES_MEDIUM = {
	medium: {},
};

const IMG_SIZES_SMALL = {
	small: { width: 768, height: 834 },
};

export const MerchandisingCard = ({ product = {}, resolution }) => {
	const { track } = useAnalytics();
	const ref = useRef();
	const isElementOnScreen = useOnScreen({ ref, triggerOnce: false });

	const merch = product.merchandising[0] || product.merchandising;

	useEffect(() => {
		if (isElementOnScreen && merch?.code) {
			track("merch_view", {
				label: merch.label,
				code: merch.code,
				position: String(merch.position),
				merchCode: merch.code,
			});
		}
	}, [isElementOnScreen, merch?.code]);

	if (product.merchandising) {
		if (product.type === LISTING_ITEM_TYPES.MERCH_CAROUSSEL) {
			return (
				<div className="listing__merchandising" ref={ref}>
					<MerchandisingCarousel
						resolution={resolution}
						merchandisingList={product.merchandising}
					/>
				</div>
			);
		}

		if (product.type === LISTING_ITEM_TYPES.MERCH_SIMPLE) {
			let imageMerch = false;

			if (resolution === RESOLUTION.LARGE || resolution === RESOLUTION.XLARGE) {
				imageMerch = (
					<BackgroundProgressiveImg
						sizes={IMG_SIZES_LARGE}
						cloudinaryOptions={MERCH_CLOUDINARY_OPTIONS}
						src={
							product.merchandising.photoLarge && product.merchandising.photoLarge.url
						}
						thumbnail={
							product.merchandising.photoLarge &&
							product.merchandising.photoLarge.thumbnail
						}
						quality={"q_auto:best"}
					/>
				);
			} else if (resolution === RESOLUTION.MEDIUM) {
				imageMerch = (
					<ProgressiveImg
						sizes={IMG_SIZES_MEDIUM}
						src={
							product.merchandising.photoLarge && product.merchandising.photoLarge.url
						}
						thumbnail={
							product.merchandising.photoLarge &&
							product.merchandising.photoLarge.thumbnail
						}
					/>
				);
			} else if (resolution === RESOLUTION.SMALL) {
				imageMerch = (
					<ProgressiveImg
						sizes={IMG_SIZES_SMALL}
						src={
							product.merchandising.photoSmall && product.merchandising.photoSmall.url
						}
						thumbnail={
							product.merchandising.photoSmall &&
							product.merchandising.photoSmall.thumbnail
						}
					/>
				);
			}

			return (
				<div className="listing__merchandising" ref={ref}>
					<Merchandising
						imageElement={imageMerch}
						position={get(product, "merchandising.position")}
						indexCarousel={get(product, "merchandising.headerIndex")}
						ctaButtonText={get(product, "merchandising.button.label")}
						ctaButtonBackgroundColor={get(
							product,
							"merchandising.button.backgroundColor"
						)}
						ctaButtonColor={get(product, "merchandising.button.color")}
						merchandisingCode={product.merchandising.code}
						endAt={product.merchandising.endAt}
						countdownPosition={get(product, "merchandising.countdown.position")}
						countdownTextColor={get(product, "merchandising.countdown.textColor")}
						countdownStartAt={get(product, "merchandising.countdown.startAt")}
						countdownEndAt={get(product, "merchandising.countdown.endAt")}
						daysInHours={get(product, "merchandising.countdown.daysInHours")}
						redirectUrl={get(product, "merchandising.redirectUrl")}
					/>
				</div>
			);
		}
	}
	return false;
};
